import { defineComponent, PropType } from 'vue'
import { SvgIcon } from '../../components/SvgIcon'
import { CharacterDetail } from './characterDetail'
import { useStore } from './state'

export const OtherCharacter = defineComponent({
  props: {
    noCautions: {
      type: Array as PropType<
        {
          character: string
          characterKor: string
          score: number
          level: number
          levelKor: string
          percent: number
        }[]
      >,
      required: true,
    },
  },
  setup (props) {
    const store = useStore()

    const toggleFold = () =>
      (store.showOtherCharacter = !store.showOtherCharacter)

    return () => {
      const { showOtherCharacter } = store
      const folded = !showOtherCharacter

      return (
        <div
          class={`transition-all rounded ${
            folded ? '' : 'shadow-lg border border-gray-400 border-solid'
          }`}
        >
          <div
            class="rounded bg-gray-100 p-5 flex items-center border border-gray-400 border-solid cursor-pointer"
            onClick={toggleFold}
          >
            <div class="font-bold">
              {props.noCautions.length === 5
                ? '다섯 캐릭터가 궁금해요!'
                : '다른 캐릭터 특징 보기'}
            </div>
            <SvgIcon
              name="down-indicator"
              class={`transition-all ml-auto ${folded ? '' : 'rotate-180'}`}
            />
          </div>
          <div
            class={`p-2 transition-all duration-300 overflow-hidden ${
              folded ? '!py-0 max-h-0' : 'max-h-[5000px]'
            }`}
          >
            <div>
              {props.noCautions
                .slice()
                .sort((a, b) => b.score - a.score)
                .map(val => (
                  <CharacterDetail class="py-8" {...val} />
                ))}
            </div>
          </div>
        </div>
      )
    }
  },
})
